import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import TepezzaWrapper from "@components/layouts/tepezzaWrapper";

export default function BestZantacLawyersHome(): ReactElement {
    return (
        <TepezzaWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <TermsAndConditions
                    category="Tepezza"
                    domain="Tepezza.Claims"
                />
            </div>
        </TepezzaWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
